export default theme => ({
  wrap: {
    width: '100%',
    maxWidth: 650,
  },
  error: {
    color: theme.palette.error.main,
    fontWeight: 700,
  },
  imageControl: {
    display: 'flex',
  },
  hidden: {
    display: 'none',
  },
  checkbox: {
    width: 40,
  },
  datepicker: {
    flex: 'none',
    width: 310,
    marginRight: 30,
  },
});
